"use strict";

exports.__esModule = true;
exports.DataItemSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _MultiFieldSelector = require("../../Recharts/Fields/MultiFieldSelector/MultiFieldSelector");
var _reactIntl = require("react-intl");
var _Device = require("../../Device");
var _constants = require("../../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DataItemSelector = exports.DataItemSelector = function DataItemSelector(props) {
  var path = props.path,
    elementEditor = props.elementEditor,
    dataItems = props.dataItems,
    devices = props.devices;
  return /*#__PURE__*/_react["default"].createElement(_MultiFieldSelector.MultiFieldSelector, {
    getKey: function getKey(input) {
      return input.dataItemName;
    },
    renderItemText: function renderItemText(input) {
      return input.dataItemName;
    },
    itemPredicate: function itemPredicate(query, _ref) {
      var dataItemName = _ref.dataItemName;
      return dataItemName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    },
    renderItemLabel: function renderItemLabel(input) {
      return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DataItemSelector.dataItemLabel.itemLabel",
        defaultMessage: "{deviceCount, number} {deviceCount, plural, one {device} other {devices}}",
        values: input
      });
    },
    selectedItems: dataItems,
    onChange: function onChange(selectedValues) {
      return elementEditor.setProp(path, "dataItems", selectedValues);
    },
    items: (0, _Device.getDeviceDataItemStats)(devices, [_constants.CATEGORY_SAMPLE])
  });
};